export const t = (key: string) => key
